import {Component} from '@angular/core';

@Component({
    selector: 'app-acessolayout',
    templateUrl: './acessolayout.component.html',
    standalone: false
})
export class AcessolayoutComponent {
}
